import React from "react";

function NXLogout({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.5V6"
      />
      <path
        d="M11 1.87646C12.0669 2.70938 12.8471 3.85456 13.2318 5.1522C13.6166 6.44984 13.5867 7.83524 13.1462 9.11506C12.7058 10.3949 11.8769 11.5053 10.775 12.2914C9.67321 13.0774 8.35348 13.4999 7 13.4999C5.64652 13.4999 4.32679 13.0774 3.22497 12.2914C2.12314 11.5053 1.29418 10.3949 0.853758 9.11506C0.413331 7.83524 0.383406 6.44984 0.768159 5.1522C1.15291 3.85456 1.93315 2.70938 3 1.87646"

      />
    </svg>
  );
}

export default NXLogout;
